<template>
	<JBox>
		<JInputText v-model="formattedLiquid" class="s-mb-2" />
		<!-- <JBaseInputSearch v-model="searchKey" class="s-mb-2" /> -->

		<div style="height: 500px; overflow-y: scroll;" class="s-bg-white s-mb-4">
			<JSpinner type="dots" class="s-mt-4" v-if="isLoading" />
			<FieldItem v-else :fieldsArray="computedQueries" :types="types" @path:added="handleAdd" @path:removed="handleRemove" />
		</div>
		<JFlex class="s-justify-end">
			<JButton @click="confirmSelection">{{ $t("core.confirm") }}</JButton>
		</JFlex>
	</JBox>
</template>

<script>
import FieldItem from "./FieldItem"

import api from "@/api/api"
import { query } from "../../api/queries"

export default {
	components: {
		FieldItem
	},

	data() {
		return {
			path: [],
			queries: [],
			types: [],
			searchKey: null,
			isLoading: false,
			formattedLiquid: null
		}
	},

	methods: {
		async getIntrospectionFromGraphQl() {
			this.isLoading = true

			const variables = {}

			const res = await api({ query: query.introspection, variables })

			this.isLoading = false

			this.queries = res?.data?.__schema?.queryType?.fields
			this.types = res?.data?.__schema?.types
		},

		handleAdd({ payload, modifiers }) {
			this.path.push({ payload, modifiers })
		},
		handleRemove({ payload }) {
			const foundIndex = this.path?.findIndex(item => item.payload.name === payload.name)
			this.path.splice(foundIndex) // remove all items in array after this index
		},
		confirmSelection() {
			this.$emit("data:selected", this.formattedLiquid)
		}
	},

	computed: {
		computedQueries() {
			return this.searchKey === null || this.searchKey === ""
				? this.queries
				: this.queries?.filter(item => item.name.includes(this.searchKey))
		}
	},

	watch: {
		path: {
			handler() {
				const path = this.path
					?.map(item => {
						// type LIST modifiers
						const modifiers = item?.modifiers
						if (modifiers && Object?.keys(modifiers)?.includes("index")) {
							return `${item?.payload?.name}[${item?.modifiers?.index}]`
						} else return item?.payload?.name
					})
					?.join(".")
				this.formattedLiquid = `{{- data.${path} -}}`
			},
			immediate: true
		}
	},

	created() {
		if (this.$store?.state?.tenantId === "fubon") return
		this.getIntrospectionFromGraphQl()
	}
}
</script>
